import Hero from './components/Hero';
import PerformancePreview from './components/PerformancePreview';
import RiskDiscipline from './components/RiskDiscipline';
import Comparison from './components/Comparison';
import HowItWorksPreview from './components/HowItWorksPreview';
import Testimonials from './components/Testimonials';
import FaqPreview, { PREVIEW_IDS } from './components/FaqPreview';
import FitSection from './components/FitSection';
import FinalCta from './components/FinalCta';
import { faqItems } from '@/mocks/faq';
import useCanonical from '@/hooks/useCanonical';

/**
 * Site-wide structured data for the homepage.
 *
 * The whole project previously had no site-level identity node, so we emit an
 * Organization plus a WebSite here — the homepage is the natural place for
 * them. Only facts that are actually visible on the site are used.
 */
const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': '/#organization',
  name: 'GoldWarden EA',
  url: '/',
  description:
    'GoldWarden EA is a free automated trading expert advisor for XAUUSD on MetaTrader 5, distributed through support chat.',
};

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  '@id': '/#website',
  name: 'GoldWarden EA',
  url: '/',
  description:
    'Live performance, strategy walkthrough and free downloads for the GoldWarden XAUUSD expert advisor on MetaTrader 5.',
  inLanguage: 'en',
  publisher: { '@id': '/#organization' },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqItems
    .filter((item) => PREVIEW_IDS.includes(item.id))
    .map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
};

export default function Home() {
  useCanonical('/');

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify([organizationSchema, websiteSchema, faqSchema]) }}
      />

      <Hero />
      <PerformancePreview />
      <RiskDiscipline />
      <Comparison />
      <HowItWorksPreview />
      <Testimonials />
      <FaqPreview />
      <FitSection />
      <FinalCta />
    </>
  );
}